
import Select from "@/components/product/components/select/index.vue";
import _ from "lodash";
import { mapGetters, mapMutations } from "vuex";
import { routeToProduct, formatWholePrice } from "@/helpers";


export default {
  name: "CatalogItem",
  components: { Select },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedOption: null,
      isInBasket: false,
      basketKey: 1,
    };
  },
  computed: {
    ...mapGetters({
      basket: "basket/basket",
      isProfessional: "profile/isProfessional",
      isDistributor: "profile/isDistributor",
    }),
    isPartner() {
      return this.isProfessional || this.isDistributor;
    },
    isProfessionalOnly() {
      const opt = this.selectedOption;
      if (!opt) return false;
      const flag = opt.show_without_price ?? opt.showWithoutPrice;
      return !!flag && !this.isPartner;
    },
    isSelectedProfessional() {
      const opt = this.selectedOption;
      if (!opt) return false;
      if (opt.show_without_price ?? opt.showWithoutPrice) return true;
      if (this.isPartner && !opt.clientPrice) return true;
      return false;
    },
  },
  watch: {
    selectedOption: {
      handler() {
        this.checkInBasket();
      },
      deep: true,
    },
    basket: {
      handler() {
        this.basketKey += 1;
        this.checkInBasket();
      },
      deep: true,
    },
  },

  created() {
    const prices = this.item?.productPrices?.data || [];
    if (prices.length) {
      this.selectedOption = prices[0];
      this.checkInBasket();
    }
  },
  methods: {
    formatWholePrice,
    routeToProduct,
    ...mapMutations({
      addToBasket: "basket/ADD_ITEM_TO_BASKET",
      changeBasketPopup: "basket/SHOW_BASKET_POPUP",
      changeLoginPopup: "popups/CHANGE_LOGIN_POPUP",
    }),

    openProfessionalOnlyModal() {
      this.changeLoginPopup(true);
    },

    checkInBasket() {
      if (!this.selectedOption?.id) {
        this.isInBasket = false;
        return;
      }
      this.isInBasket = _.some(this.basket, { select_type: { id: this.selectedOption.id } });
    },

    addBasket() {
      if (!this.selectedOption) return;

      const isPartner = this.isProfessional || this.isDistributor;
      const professionalOnly = this.selectedOption.showWithoutPrice;

      if (professionalOnly && !isPartner) {
        this.openProfessionalOnlyModal();
        return;
      }

      if (this.item.hasDuplicate) {
        this.$toasted?.info?.("Цей товар переміщено до нової серії та його неможливо купити");
        return;
      }

      this.addToBasket({
        select_count: 1,
        product_price: this.selectedOption,
        product: this.item,
        unauthorizedProductPriceId: this.item.unauthorizedProductPriceId,
      });

      this.changeBasketPopup(true);
      this.checkInBasket();
    },
  },
};
